<template>
  <div class="subview tickets">
    <template v-if="!loading">
      <!-- Has dates -->
      <template v-if="dates && dates.length > 0">
        <h2 class="h3">Sélectionnez une date</h2>
        <!-- Select -->
        <selection
          :id="'select-dates'"
          :options="dates"
          :placeholder="'Sélectionnez une date'"
          :selected="basket.datas.date"
          @option="onDateOption"
        />
      </template>
      <!-- Has no dates -->
      <template v-else>
        <p class="subview-noresult">Il n'y a plus aucune place de disponible.<br> Vous pouvez néanmoins vous inscrire à la liste d'attente par mail à <a href="mailto:Billetterie@theatredeliege.be">Billetterie@theatredeliege.be</a></p>
      </template>

      <!-- Has dates && one is selected-->
      <template v-if="basket.datas.event">
        <h2 class="h3">Sélectionnez le nombre de ticket</h2>
        <div class="subview-tickets">
          <div
            v-for="cat in basket.datas.event.products.categories"
            :key="`ticket-${cat.id}`"
            class="subview-cat"
          >
            <h3 v-if="cat.label" class="subview-cat-title">{{ cat.label }}</h3>

            <div
              v-for="price in cat.prices"
              :key="`ticket-prrice-${price.id}`"
              class="subview-ticket"
            >
              <span class="subview-ticket-title">{{ price.label }}</span>
              <span class="subview-ticket-price">{{ price.value.amount }}€</span>

              <div class="subview-ticket-actions">
                <button
                  v-if="!basket.attraction.item.stream"
                  @click.prevent="onRemove(price)"
                  :disabled="ticketCount(price) === 0"
                  class="actions-button"
                >
                  <sprite
                    :type="'remove'"
                    :width="13"
                    :height="4"
                  />
                </button>

                <span class="actions-count">{{ ticketCount(price) }}</span>

                <button
                  v-if="!basket.attraction.item.stream"
                  @click.prevent="onAdd(price)"
                  :disabled="ticketCount(price) === price.quantity_max"
                  class="actions-button"
                >
                  <sprite
                    :type="'add'"
                    :width="12"
                    :height="12"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="subview-total">
          <span class="subview-total-label">Total</span>
          <span class="subview-total-count">{{ totalCount }}€</span>
        </div>
      </template>

      <pagination
        :back="false"
        :nextDisable="basket.datas.tickets.length === 0 || !basket.datas.date"
        @next="onNext"
      />
    </template>
  </div>
</template>

<script>
// import Loader from '@/components/components/Loader.vue';
import Sprite from '@/components/components/Sprite.vue';
import Selection from '@/components/components/Selection.vue';
import Pagination from '@/components/partials/Pagination.vue';

export default {
  components: {
    // Loader,
    Sprite,
    Selection,
    Pagination
  },
  computed: {
    dates() {
      const attraction = this.$store.state.basket.attraction.item;
      if (!attraction) {
        return [];
      }

      // eslint-disable-next-line
      const dates = attraction.events.map(e => {
        return {
          label: e.date,
          value: e.id
        };
      });

      return dates;
    },
    basket() {
      return this.$store.state.basket;
    },
    datas() {
      return this.$store.state.basket.datas;
    },
    totalCount() {
      let total = 0;

      this.$store.state.basket.datas.tickets.map(t => {
        total += t.value.amount * t.quantity;
      });

      return total;
    },
    loading() {
      return this.$store.state.basket.requests !== 0;
    }
  },
  methods: {
    onDateOption(option) {
      if (!option) {
        this.$store.commit('basket/setDate', null);
        this.$store.commit('basket/setEvent', null);
        this.$store.commit('basket/resetTickets');
        return;
      }

      if (this.basket.datas.event && option.value !== this.basket.datas.event.id) {
        this.$store.commit('basket/resetTickets');
      }

      this.$store.commit('basket/setDate', option);
      this.$store.commit('basket/setEvent', option.value);
    },
    // eslint-disable-next-line
    ticketCount(ticket) {
      const tick = this.$store.state.basket.datas.tickets.filter(t => t.id === ticket.id && t.categoryid === ticket.categoryid);

      if (tick.length > 0) {
        return tick[0].quantity;
      }

      return 0;
    },
    onRemove(ticket) {
      this.$store.commit('basket/removeTicket', ticket);
    },
    onAdd(ticket) {
      this.$store.commit('basket/addTicket', ticket);
    },
    async onNext() {
      if (this.$store.state.basket.datas.orderid) {
        // eslint-disable-next-line
        const reset = await this.$store.dispatch('basket/resetOrder');
      }

      // eslint-disable-next-line
      const request = await this.$store.dispatch('basket/requestStock', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.subview {
  .h3 {
    &:not(:first-child) {
      @include margin(35px null null);
    }
  }

  .selection {
    @include margin(16px null null);
  }

  &-cat {
    &-title {
      @include margin(30px null 16px);
      font-size: rem(20px);
      font-weight: 700;
      line-height: (24 / 20);
    }
  }

  &-tickets {
    @include margin(35px null null);
  }

  &-ticket {
    @include padding(16px);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    background-color: $black-light;

    + .subview-ticket {
      @include margin(16px null null);
    }

    &-title {
      @include margin(null null 9px);
      width: 100%;
      font-size: rem(19px);
      line-height: (23 / 19);
    }

    &-price {
      @include font('secondary', 'medium');
      @include padding(3px null null);
      font-size: rem(20px);
      line-height: (24 / 20);
    }

    &-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .actions-button {
        @include size(36px);
        position: relative;
        border-radius: 50%;
        background-color: $primary;
        outline: none;

        &[disabled] {
          opacity: .3;
        }

        .svg {
          @include position(absolute, 50% null null 50%);
          transform: translate(-50%, -50%);
          fill: $white;
        }
      }

      .actions-count {
        @include padding(3px null null);
        @include font('secondary', 'regular');
        width: 44px;
        font-size: rem(20px);
        line-height: (24 / 20);
        text-align: center;
      }
    }
  }

  &-bottomline {
    @include margin(16px null null);
    font-size: rem(14px);
    line-height: 1.5;
  }

  &-total {
    @include margin(40px null null);
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    &-label {
      font-size: rem(36px);
      line-height: (43 / 36);
    }

    &-count {
      @include font('secondary', 'medium');
      font-size: rem(28px);
      line-height: (33 / 28);
    }
  }

  &-noresult {
    font-size: rem(18px);
    line-height: (26 / 22);

    a {
      color: $primary;
    }
  }
}
</style>
